import { NewCorporateCardView } from '@/components/Approval/@components/NewCorporateCard';
import { parseNewCorporateCardAttributes } from '@/utils/approval/newCorporateCard';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 204 신규입사자 법인카드 — 레거시 조회처럼 저장값이 없으면 본문 영역을 숨김 */
const NewCorporateCardSlot = ({ data }: ContentExtraProps) => {
  const saved = parseNewCorporateCardAttributes(data.attributes);
  if (!saved) return null;
  return (
    <ContentSlotRoot>
      {/* 모달에서 다음 문서로 넘어가도 컴포넌트가 유지돼 인증 상태가 따라감 — 문서별로 새로 */}
      <NewCorporateCardView key={data.documentId} data={saved} />
    </ContentSlotRoot>
  );
};

export default NewCorporateCardSlot;
